import { Icon, IconProps } from "@chakra-ui/react";

const PersonFillIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        d="M3 14C3 14 2 14 2 13C2 12 3 9 8 9C13 9 14 12 14 13C14 14 13 14 13 14H3ZM8 8C8.79565 8 9.55871 7.68393 10.1213 7.12132C10.6839 6.55871 11 5.79565 11 5C11 4.20435 10.6839 3.44129 10.1213 2.87868C9.55871 2.31607 8.79565 2 8 2C7.20435 2 6.44129 2.31607 5.87868 2.87868C5.31607 3.44129 5 4.20435 5 5C5 5.79565 5.31607 6.55871 5.87868 7.12132C6.44129 7.68393 7.20435 8 8 8Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default PersonFillIcon;
